"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.home_geography = exports.household_size = void 0;
const project_config_1 = __importDefault(require("chaire-lib-common/lib/config/shared/project.config"));
const defaultInputBase = __importStar(require("evolution-frontend/lib/components/inputs/defaultInputBase"));
const frontendHelper_1 = require("evolution-frontend/lib/services/display/frontendHelper");
const activityIconMapping_1 = require("evolution-common/lib/services/questionnaire/sections/visitedPlaces/activityIconMapping");
const surveyHelperNew = __importStar(require("evolution-common/lib/utils/helpers"));
const defaultConditional_1 = require("evolution-common/lib/services/widgets/conditionals/defaultConditional");
const validations = __importStar(require("evolution-common/lib/services/widgets/validations/validations"));
const customValidations = __importStar(require("../../common/customValidations"));
const customGeoData_1 = require("../../common/customGeoData");
const customHelpPopup = __importStar(require("../../common/customHelpPopup"));
exports.household_size = Object.assign(Object.assign({}, defaultInputBase.inputRadioNumberBase), { path: 'household.size', twoColumns: false, containsHtml: true, label: (t, interview) => {
        const assignedDay = surveyHelperNew.getResponse(interview, '_assignedDay');
        const assignedDate = (0, frontendHelper_1.getFormattedDate)(assignedDay, { withDayOfWeek: true, withRelative: true });
        return t('home:household.size', {
            assignedDate
        });
    }, valueRange: {
        min: 1,
        max: 6
    }, overMaxAllowed: true, helpPopup: customHelpPopup.householdSizeHelpPopup, conditional: defaultConditional_1.defaultConditional, validations: validations.householdSizeValidation });
exports.home_geography = Object.assign(Object.assign({}, defaultInputBase.inputMapFindPlaceBase), { path: 'home.geography', label: (t, _interview, _path) => {
        return t('home:home.geography');
    }, icon: {
        url: (0, activityIconMapping_1.getActivityMarkerIcon)('home'),
        size: [70, 70]
    }, placesIcon: {
        url: (interview, path) => '/dist/icons/interface/markers/marker_round_with_small_circle.svg',
        size: [35, 35]
    }, selectedIcon: {
        url: (interview, path) => '/dist/icons/interface/markers/marker_round_with_small_circle_selected.svg',
        size: [35, 35]
    }, geocodingQueryString: (interview) => {
        // TODO: Add country and region to the geocoding query string
        const city = surveyHelperNew.getResponse(interview, 'home.city', null);
        const address = surveyHelperNew.getResponse(interview, 'home.address', null);
        const postalCode = surveyHelperNew.getResponse(interview, 'home.postalCode', null);
        // Fields to use for geocoding
        const fieldsAddress = [];
        // Postal code is optional
        if (postalCode !== null) {
            fieldsAddress.push(postalCode);
        }
        fieldsAddress.push(city, address);
        return [{ queryString: surveyHelperNew.formatGeocodingQueryStringFromMultipleFields(fieldsAddress), zoom: 16 }];
    }, defaultCenter: project_config_1.default.mapDefaultCenter, defaultZoom: project_config_1.default.mapDefaultZoom, invalidGeocodingResultTypes: customGeoData_1.defaultInvalidGeocodingResultTypes, validations: (value, _customValue, interview, path) => customValidations.getGeographyCustomValidation({
        value,
        interview,
        path
    }) });
